import * as React from 'react';
import OtherLinks from '../../components/OtherLinks';
import Footer from '../../components/Footer';
import PortalIntegration from '../../PortalIntegration';
import Config from '../../Config';
import * as FunctionFile from '../../FunctionFile';

class ComposeMessageProps {
}

class ComposeMessageState {
    username: string;
}

export default class ComposeMessage extends React.Component<ComposeMessageProps, ComposeMessageState> {

    constructor(props: ComposeMessageProps) {
        super(props);

        var username = Config.getOverrideUsername() || Office.context.mailbox.userProfile.emailAddress;

        this.state = {
            username: username,
        };
    }

    componentDidMount() {

    }

    render() {

        var composeUrl: string = PortalIntegration.makeRequireLoginUrl(this.state.username, "/Compose");

        return <div className="ComposeMessage ms-font-m ms-welcome">
            <div className="ms-u-slideUpIn20">
                <h2 className="ms-font-xxl">Encrypted Email</h2>
                {/*<a target="_blank" className="ms-Button ms-Button--primary" href={composeUrl} onClick={(e) => { e.preventDefault(); FunctionFile.showComposeDialog(); }}>
                    <span className="ms-Button-label">New Encrypted Email</span>
                </a>*/}
                <OtherLinks username={this.state.username} />
            </div>
            <Footer />
        </div>;
    }

}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/tasks/ComposeMessage/ComposeMessage.tsx